/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_Turn_OffInputs */

const en_simple_home_banner_turn_off = /** @type {(inputs: Simple_Home_Banner_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to developer mode`)
};

const id_simple_home_banner_turn_off = /** @type {(inputs: Simple_Home_Banner_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke mode developer`)
};

/**
* | output |
* | --- |
* | "Back to developer mode" |
*
* @param {Simple_Home_Banner_Turn_OffInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_turn_off = /** @type {((inputs?: Simple_Home_Banner_Turn_OffInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_Turn_OffInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_turn_off(inputs)
	return en_simple_home_banner_turn_off(inputs)
});